import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("wm_admin_token")) navigate("/admin");
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("wm_admin_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black grid place-items-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-[#0b0b0b] p-8 fade-up" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-1">
          <span className="w-9 h-9 grid place-items-center bg-primary text-primary-foreground font-head font-black">WM</span>
          <span className="font-head font-extrabold uppercase tracking-tight">Window Tint</span>
        </div>
        <h1 className="mt-6 text-2xl font-head font-black uppercase tracking-tight flex items-center gap-2"><Lock className="w-5 h-5 text-primary" /> Admin Login</h1>
        <div className="mt-6 space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wide text-muted-foreground">Email</Label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none bg-black border-white/10 mt-1" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wide text-muted-foreground">Password</Label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none bg-black border-white/10 mt-1" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-none bg-primary text-primary-foreground font-bold uppercase tracking-wider">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </div>
      </form>
    </div>
  );
}
